export default __webpack_public_path__ + "static/media/other-cat.8bc7af0a.webp";